if (!customElements.get("selectable-chips")) {
  customElements.define(
    "selectable-chips",
    class SelectableChips extends HTMLElement {
      constructor() {
        super();
        this.key = this.dataset.key;
      }

      connectedCallback() {
        // this.initChips();
        // this.restoreSelection(); // Restore state from URL on load

        this.observeHistoryChanges(this.updateCustomFiltersContent.bind(this));
      }

      observeHistoryChanges(callback) {
        // Prevent double patching
        if (window.__historyObserverPatched) return;
        window.__historyObserverPatched = true;

        const originalPushState = history.pushState;
        const originalReplaceState = history.replaceState;

        const fireEvent = () => callback(window.location.href);

        history.pushState = function (...args) {
          originalPushState.apply(this, args);
          fireEvent();
        };

        history.replaceState = function (...args) {
          originalReplaceState.apply(this, args);
          fireEvent();
        };

        window.addEventListener("popstate", fireEvent);
        window.addEventListener("hashchange", fireEvent);

        // Optional: trigger immediately
        fireEvent();
        this.addChipListeners();
      }

      updateCustomFiltersContent() {
        const currentParams = new URLSearchParams(window.location.search);
        let keyParams, value;
        document
          .querySelectorAll(".js-selectable-chips")
          .forEach(function (customFilters) {
            customFilters
              .querySelectorAll(".js-selectable-chip")
              .forEach(function (filter) {
                keyParams = currentParams.getAll(
                  filter.getAttribute("data-key")
                );
                if (keyParams.includes(filter.getAttribute("data-value"))) {
                  filter.classList.add("selected");
                  filter.querySelector("input").checked = true;
                } else {
                  filter.classList.remove("selected");
                  filter.querySelector("input").checked = false;
                }
              });
          });
      }

      addChipListeners() {
        const currentParams = new URLSearchParams(window.location.search);
        let keyParams, value;
        document
          .querySelectorAll(".js-selectable-chips")
          .forEach(function (customFilters) {
            keyParams = currentParams.getAll(
              customFilters.getAttribute("data-key")
            );
            customFilters
              .querySelectorAll(".js-selectable-chip")
              .forEach(function (filter) {
                filter.addEventListener("click", () => {
                  value = filter.getAttribute("data-value");
                  keyParams = currentParams.getAll(
                    filter.getAttribute("data-key")
                  );
                  if (keyParams.includes(value)) {
                    filter.classList.remove("selected");
                  } else {
                    filter.classList.add("selected");
                  }
                });
              });
          });
      }

      initChips() {
        const chips = document.querySelectorAll(".js-selectable-chip");

        chips.forEach((chip) => {
          chip.addEventListener("click", () => {
            const value = chip.dataset.value;
            const currentParams = new URLSearchParams(window.location.search);

            const values = currentParams.getAll(this.key);
            if (values.includes(value)) {
              chip.classList.remove("selected");
            } else {
              chip.classList.add("selected");
            }
            // this.updateURL();
          });
        });
      }

      restoreSelection() {
        const currentParams = new URLSearchParams(window.location.search);
        const selectedValues = currentParams.getAll(this.key);

        // Restore selected state for matching chips
        this.querySelectorAll(".js-selectable-chip").forEach((chip) => {
          if (selectedValues.includes(chip.dataset.value)) {
            chip.classList.add("selected");
          }
        });
      }
    }
  );
}
